import { render, staticRenderFns } from "./RightSwiper.vue?vue&type=template&id=38689c49&scoped=true"
import script from "./RightSwiper.vue?vue&type=script&lang=js"
export * from "./RightSwiper.vue?vue&type=script&lang=js"
import style0 from "./RightSwiper.vue?vue&type=style&index=0&id=38689c49&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38689c49",
  null
  
)

export default component.exports